<script lang="tsx">
  import { isFunction, isArray, map } from 'lodash'
  import {
    defineComponent,
  } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'

  export default defineComponent({
    name: 'Paragraph',
    functional: true,
    props: {
      content: {
        type: [String, Function, Array],
      },
      bs: {
        type: Object,
        default: () => ({}),
      },
    },
    setup(props) {
      return () => {
        const { content, bs } = props
        let lst = content
        if (!isArray(lst)) {
          lst = [lst]
        }
        return (
          <NewBsBox bs={bs}>
            {
              map(lst, txt => {
                let text = txt
                if (isFunction(text)) {
                  text = text()
                }
                return <NewBsBox>{text}</NewBsBox>
              })
            }
          </NewBsBox>
        )
      }
    },
  })
</script>
